import React from "react"
import { withRouter } from "react-router"
import { Route, Switch, NavLink, Link } from "react-router-dom";
import { has } from "lodash"

import ManageHeader from "./ManageHeader"
import GameTitle from "./GameTitle"

import InviteTesters from "./manageSections/InviteTesters"
import LatestReviews from "./manageSections/LatestReviews"
import ManageBuild from "./manageSections/ManageBuild"

import { User } from "./../../../CheckLogin"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserPlus, faCommentAlt, faWrench, faSpinner } from "@fortawesome/free-solid-svg-icons"
import InviteCollaborators from "./manageSections/InviteCollaborators";

class Manage extends React.Component{
    constructor(){
        super()
        this.state={
            data: null,
            isLoading: true,
            error: "",
        }
    }
    componentDidMount(){
        fetch(`/api/data/project/${this.props.match.params.id}`)
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.setState({ 
                data: data.result,
                isLoading: false
            })
        })
        .catch(data => this.setState({error: `Server: ${data.error}`, isLoading: false}))
    }
    render(){
        //if project is not owned by user
        if ( this.state.error !== "" ){
            return(
                <User.Consumer>
                    {(user) => (
                        <div className="loadingWrapper">
                            <div className="loading">{this.state.error}<br/>
                                <Link to={{
                                        pathname: "/console/user/" + user.id
                                    }}>
                                    Return to console
                                </Link>
                            </div>
                        </div>
                    )}
                </User.Consumer>
            )
        }
        const { data } = this.state
        if (this.state.isLoading === true){
            return(
                <div className="loadingWrapper">
                    <div className="loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
                </div>
            )
        }
        const { id, name, createdAt, updatedAt, 
            userId, greenlit} = data
        const imgUrl = `/api/store/project/${id}/image`
        const isPrivate = data.private
        const { path, url } = this.props.match
        return(
            <div className="mainContent">
            <ManageHeader userId={userId} gameName={name}/>
                <div className="manageBody">
                    <GameTitle imgUrl ={imgUrl} gameName={name} id={id} userId={userId}
                        createdAt={createdAt} updatedAt={updatedAt} 
                        isPrivate={isPrivate}/>
                {/* links to different routes */}
                <div className="switchSections">
                    {
                        <NavLink to={`${url}/invite`} activeClassName="current">
                                <FontAwesomeIcon icon={faUserPlus} />Invite Testers
                        </NavLink>
                    }
                    {
                        <NavLink to={`${url}/invite_collaborator`} activeClassName="current">
                            <FontAwesomeIcon icon={faUserPlus} />Invite Collaborators
                        </NavLink>
                    }
                    <NavLink to={`${url}/reviews`} activeClassName="current">
                            <FontAwesomeIcon icon={faCommentAlt} />Latest Reviews
                    </NavLink>
                    {greenlit === true
                        ?
                        <NavLink to={`${url}/build`} activeClassName="current">
                            <FontAwesomeIcon icon={faWrench} />Request Build
                        </NavLink>
                        : null}
                </div>
                    <Switch>
                        <Route path={`${path}/invite`}><InviteTesters id={id} /></Route>
                        <Route path={`${path}/invite_collaborator`}><InviteCollaborators id={id} /></Route>
                        <Route path={`${path}/reviews`}><LatestReviews id={id} /></Route>
                        <Route path={`${path}/build`}>
                            <User.Consumer>
                                {(user)=>(
                                    <ManageBuild id={id} user={user}/>
                                )}
                            </User.Consumer>
                        </Route>
                    </Switch>
                </div>
            </div>
        )
    }
}

export default withRouter(Manage)